/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconAntennaBars5 = createReactComponent("antenna-bars-5", "IconAntennaBars5", [
  ["path", { d: "M6 18l0 -3", key: "svg-0" }],
  ["path", { d: "M10 18l0 -6", key: "svg-1" }],
  ["path", { d: "M14 18l0 -9", key: "svg-2" }],
  ["path", { d: "M18 18l0 -12", key: "svg-3" }]
]);

export { IconAntennaBars5 as default };
//# sourceMappingURL=IconAntennaBars5.js.map
